unable to read source [project]/node_modules/https-proxy-agent/src/agent.ts